export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14149.ec390125.jpg";